import { SVGProps } from 'react';

const CursorClick = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <g clipPath="url(#clip0_7292_12184)">
        <path
          d="M22.5328 11.4582H26.9066M20.6113 16.0972L23.704 19.19M8.74185 4.30022L11.8346 7.39295M16.4736 1.09766V5.4714M24.2054 4.30022L21.1127 7.39295M5.93603 18.9674L3.2803 21.6231C2.42627 22.4772 2.42627 23.8618 3.2803 24.7159C4.13433 25.5699 5.519 25.5699 6.37303 24.7159L9.02876 22.0601L10.5505 25.5837C10.66 25.8371 10.8167 26.0673 11.0121 26.2622C11.8661 27.1162 13.2508 27.1162 14.1048 26.2622C14.3851 25.9828 14.5839 25.6323 14.6799 25.2483L17.7726 12.8775C17.9528 12.1568 17.7611 11.3622 17.1976 10.7987C16.634 10.2351 15.8394 10.0434 15.1187 10.2236L2.74779 13.3164C2.36385 13.4123 2.01332 13.6111 1.7339 13.8914C0.879877 14.7454 0.879877 16.1301 1.7339 16.9841C1.92884 17.1795 2.15907 17.3362 2.41238 17.4457L5.93603 18.9674Z"
          stroke="#14B8FA"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7292_12184">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CursorClick;
